import { render, staticRenderFns } from "./ChangePasswordDone.vue?vue&type=template&id=2baa8ad1&scoped=true"
import script from "./ChangePasswordDone.vue?vue&type=script&lang=js"
export * from "./ChangePasswordDone.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordDone.vue?vue&type=style&index=0&id=2baa8ad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa8ad1",
  null
  
)

export default component.exports